/** @jsx jsx */
import { jsx } from '@emotion/react';

import ComplexCollectionComponent from 'bundles/browse-common/components/ComplexCollectionComponent/ComplexCollectionComponent';
import { toComplexCollection } from 'bundles/browse-common/renderers/ComplexCollectionRenderer/toComplexCollection';
import { usePageConfigComponentTrackingData } from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';
import type { PageConfig_ComponentConfig_PageConfig_CollectionComponent_Fragment as PageConfigCollectionComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

type Props = {
  pageConfig: PageConfigCollectionComponent;
  twoColumnLayout?: boolean;
  hideSecondaryCta?: boolean;
};

const ComplexCollectionRenderer = (props: Props) => {
  const { pageConfig, twoColumnLayout, hideSecondaryCta } = props;
  const { collectionEntity, secondaryCta } = pageConfig;
  const pageConfigComponentTrackingData = usePageConfigComponentTrackingData();

  if (collectionEntity.__typename !== 'Recommendation_Collection') return null;

  const { first, filters } = toComplexCollection(collectionEntity) ?? {};

  if (!first || !filters) return null;

  return (
    <ComplexCollectionComponent
      title={collectionEntity.description}
      firstCollection={first}
      filters={filters}
      secondaryCta={secondaryCta}
      pageConfigComponentTrackingData={pageConfigComponentTrackingData}
      twoColumnLayout={twoColumnLayout}
      hideSecondaryCta={hideSecondaryCta}
    />
  );
};

export default ComplexCollectionRenderer;
